import { View } from 'common/types/view';
import includes from 'lodash/includes';

export const isDataFederationUnsupportedAssetType = ({ displayType }: Partial<View>) => {
  // The `isDataFederationUnsupportedAssetType()` method in the View model in Core implements this same logic.
  return includes(['calendar', 'chart', 'form', 'map'], displayType);
};
